import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import { AuthProvider } from './contexts/AuthContext'
import ProtectedRoute from './components/ProtectedRoute'
import AdminLayout from './layouts/AdminLayout'
import LoginPage from './pages/LoginPage'
import ResetPasswordPage from './pages/ResetPasswordPage'
import DashboardPage from './pages/DashboardPage'
import AgenciesPage from './pages/agencies/AgenciesPage'
import AgencyFormPage from './pages/agencies/AgencyFormPage'
import AgencyRequestsPage from './pages/agencies/AgencyRequestsPage'
import UsersPage from './pages/users/UsersPage'
import QRCodePage from './pages/QRCodePage'

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 3000,
            style: {
              borderRadius: '12px',
              background: '#1a1a2e',
              color: '#fff',
              fontSize: '14px',
            },
          }}
        />
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route
            element={
              <ProtectedRoute allowedRoles={['super_admin', 'admin']} />
            }
          >
            <Route element={<AdminLayout />}>
              <Route path="/" element={<DashboardPage />} />
              <Route path="/agencies" element={<AgenciesPage />} />
              <Route path="/agency-requests" element={<AgencyRequestsPage />} />
              <Route path="/agencies/new" element={<AgencyFormPage />} />
              <Route path="/agencies/:id/edit" element={<AgencyFormPage />} />
              <Route path="/users" element={<UsersPage />} />
              <Route path="/qr-code" element={<QRCodePage />} />
            </Route>
          </Route>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  )
}

export default App
